/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';


export interface AssociateStationSvgFile$Params {

/**
 * The object ID. Must be a valid ID.
 */
  uid: string;

/**
 * The uid of the selected svg
 */
  svgUid: string;
      body?: Blob
}

export function associateStationSvgFile(http: HttpClient, rootUrl: string, params: AssociateStationSvgFile$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
  const rb = new RequestBuilder(rootUrl, associateStationSvgFile.PATH, 'post');
  if (params) {
    rb.path('uid', params.uid, {});
    rb.path('svgUid', params.svgUid, {});
    rb.body(params.body, 'image/svg+xml');
  }

  return http.request(
    rb.build({ responseType: 'text', accept: '*/*', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return (r as HttpResponse<any>).clone({ body: undefined }) as StrictHttpResponse<void>;
    })
  );
}

associateStationSvgFile.PATH = '/stations/{uid}/svg/{svgUid}/file';
